<div class="setting-page setting-page-full-width">
  <div class="routing-server-groups">
    <legend>Routing Server Groups</legend>

    <div class="search-and-actions">
      <div class="search-container">
        <arm-search (onSearch)="onSearch($event)"
                    [searchComponent]="routingServersSearchComponent"
                    [searchData]="searchData"
                    [searchTerms]="searchTerms">
        </arm-search>
      </div>

      <div class="action-buttons">
        <arm-action-bar (addClick)="addGroup()" [disableAdd]="isUnauthorized"
                        (editClick)="editGroup()" [disableEdit]="isUnauthorized || !selection"
                        (deleteClick)="deleteGroup()" [disableDelete]="isUnauthorized || !selection"
                        (refreshClick)="refresh()"></arm-action-bar>
      </div>
    </div>

    <div class="routing-server-group-table">
      <arm-table [displayedColumns]="displayedColumns"
                 (onSelection)="onSelection($event)" [data]="serverGroups"
                 [isMultipleSelection]="false"
                 [isClientSide]="true"></arm-table>
    </div>
  </div>
</div>
